define ['./success.css'], () ->
  ($scope, $state) ->


// WEBPACK FOOTER //
// ./components/dashboard/payments/signup/success/success.coffee